import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} pram0
 * @param {string} pram0.label
 * @param {boolean} pram0.isLabelHtml
 */
const ClassesItemLabel = ({ label, isLabelHtml }) =>
    isLabelHtml ? (
        <span
            className="layer-library-classes__item-label"
            dangerouslySetInnerHTML={{ __html: label }}
        />
    ) : (
        <span className="layer-library-classes__item-label">{label}</span>
    );

ClassesItemLabel.propTypes = {
    label: PropTypes.string.isRequired,
};

export default ClassesItemLabel;
